const TABS = [
  { id: 'typography', label: 'Typography' },
  { id: 'buttons', label: 'Buttons' },
  { id: 'tags', label: 'Tags' },
  { id: 'colors', label: 'Colors' },
]

export default function TabNavigation({ activeTab, onTabChange }) {
  return (
    <div className="mb-40">
      <nav className="flex flex-col t:flex-row gap-8" aria-label="Tabs">
        {TABS.map((tab) => {
          const isActive = activeTab === tab.id
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                ${
                  isActive
                    ? 'bg-dark-blue-dark-blue2 text-basic-white border-dark-blue-dark-blue2'
                    : 'bg-basic-white border-dark-blue-dark-blue2 text-dark-blue-dark-blue2 hover:bg-dark-blue-dark-blue6 active:bg-dark-blue-dark-blue6 active:border-dark-blue-dark-blue1 active:text-dark-blue-dark-blue1'
                }
                border border-solid inline-flex items-center justify-center gap-8 transition-colors cursor-pointer
                pt-10 pb-12 px-20 font-bold text-buttons-m leading-100 font-serif
                focus-visible:outline-none focus-visible:border-2 focus-visible:border-functional-focus-color focus-visible:rounded focus-visible:p-4
                w-full t:w-auto
              `}
              aria-current={isActive ? 'page' : undefined}
              aria-controls={`panel-${tab.id}`}
              id={`tab-${tab.id}`}
            >
              <div className="flex gap-2.5 items-center justify-center py-0 px-0 relative shrink-0">
                <span className="text-buttons-m font-bold leading-100 font-serif not-italic relative shrink-0 whitespace-pre">
                  {tab.label}
                </span>
              </div>
            </button>
          )
        })}
      </nav>
    </div>
  )
}
